/**
 * Coarse user-agent classification for session metadata — the SPA-side counterpart of the two
 * helpers in apps/worker/src/bot.js (the report classifies at the edge, where the raw UA never
 * needs to leave the Worker; the quote page has no edge hop, so it classifies in the browser
 * and sends ONLY the coarse result — the schema deliberately never stores a full UA string).
 *
 * Kept byte-compatible with bot.js's vocabulary: device_type ∈ mobile|tablet|desktop and
 * ua_family like "Safari/iOS". If bot.js's rules change, change these to match — folding the
 * Worker onto this file is a welcome follow-up, but touching the live Worker was out of scope
 * when this package was extracted.
 */

export function coarseUaFamily(ua) {
  if (!ua) return "";
  const s = ua.toLowerCase();
  const os = s.includes("iphone") || s.includes("ipad") ? "iOS"
    : s.includes("android") ? "Android"
    : s.includes("mac os x") ? "macOS"
    : s.includes("windows") ? "Windows"
    : s.includes("linux") ? "Linux"
    : "";
  // Order matters: Edge and Chrome both claim Safari, Edge also claims Chrome.
  const browser = s.includes("edg/") ? "Edge"
    : s.includes("opr/") || s.includes("opera") ? "Opera"
    : s.includes("firefox") ? "Firefox"
    : s.includes("chrome") || s.includes("crios") ? "Chrome"
    : s.includes("safari") ? "Safari"
    : "Other";
  return os ? `${browser}/${os}` : browser;
}

export function deviceType(ua) {
  const s = (ua || "").toLowerCase();
  if (s.includes("ipad") || (s.includes("android") && !s.includes("mobile"))) return "tablet";
  if (s.includes("mobile") || s.includes("iphone") || s.includes("android")) return "mobile";
  return "desktop";
}
